import React from "react";

import emailjs from "emailjs-com";
import { Link } from "react-router-dom";
import { IAS_PEDAGOGY } from "../../app-constants";

const ContactForm = (props) => {
  function sendEmail(e) {
    e.preventDefault();

    emailjs.sendForm("", "", e.target, "").then(
      (result) => {
        console.log(result.text);
      },
      (error) => {
        console.log(error.text);
      }
    );

    e.target.reset();
  }

  return (
    <div className="react-blog-form">
      <h2 className="contact-title">
        Questions? <br /> Feel free to contact us.
      </h2>
      <div id="blog-form" className="blog-form">
        <div id="form-messages"></div>
        {/* <form id="contact-form" onSubmit={sendEmail}> */}
        <form id="contact-form">
          <div className="col-lg-12">
            <Link
              to={`https://wa.me/${
                IAS_PEDAGOGY.WHATSAPP_CHAT
              }?text=${encodeURIComponent(IAS_PEDAGOGY.WHATSAPP_CHAT_MESSAGE)}`}
              className="start-btn"
              target="_blank"
            >
              <button type="submit" className="back-btn">
                Send Message{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  className="feather feather-arrow-right"
                >
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </button>
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;
